import React from "react";

/**
* @param props {{
  width?: string | number;
  height?: string | number;
* }}
*/

const EYLogo = ({ width, height }) => {
    return (
        <img 
            src="/logo.svg" 
            alt="EY Logo"
            width={width || "34px"} 
            height={height || "36px"}
            style={{ display: 'block', maxWidth: 'none', maxHeight: 'none', verticalAlign: 'middle' }}
        />
    );
}

export default EYLogo;